// Ajoute/retire automatiquement les produits-cadeaux réels du panier Shopify
// selon la quantité du produit déclencheur, pour que les cadeaux (rendus gratuits
// par les réductions automatiques "Achetez X, obtenez Y") suivent jusqu'au checkout.
(function () {
  const CART_MUTATION_PATTERNS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartMutationUrl(url) {
    if (!url) return false;
    return CART_MUTATION_PATTERNS.some((pattern) => url.includes(pattern));
  }

  const configEl = document.getElementById('cart-gifts-sync-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    console.error('[cart-gifts-sync] Config JSON invalide', error);
    return;
  }

  // Sécurité : un cadeau mal configuré (handle pointant vers le produit déclencheur
  // lui-même) ne doit jamais pouvoir déclencher l'ajout d'un pot supplémentaire du
  // produit principal. On filtre ces cas une fois pour toutes au chargement.
  const gifts = (config.gifts || []).filter((gift) => {
    if (!gift.enabled || !gift.variantId) return false;

    if (config.triggerProductId && gift.productId === config.triggerProductId) {
      console.error(
        '[cart-gifts-sync] Le cadeau "' +
          gift.label +
          '" pointe vers le même produit que le produit déclencheur (handle mal configuré). Ce cadeau est ignoré pour éviter d\'ajouter des pots en trop.'
      );
      return false;
    }

    return true;
  });

  // --- Overlay de chargement -------------------------------------------------
  // Pendant que le script ajoute/retire des cadeaux en arrière-plan (et pendant le
  // rechargement de page qui suit), on bloque les clics du client sur le reste de
  // la page.
  let overlayEl = null;

  function ensureOverlay() {
    if (overlayEl) return overlayEl;

    overlayEl = document.createElement('div');
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:2147483647',
      'display:none',
      'cursor:wait',
      'background:transparent'
    ].join(';');

    const spinner = document.createElement('div');
    spinner.textContent = 'Mise à jour du panier…';
    spinner.style.cssText = [
      'position:fixed',
      'bottom:16px',
      'right:16px',
      'padding:8px 14px',
      'border-radius:999px',
      'background:rgba(20,20,20,0.85)',
      'color:#fff',
      'font-size:12px',
      'font-family:sans-serif',
      'box-shadow:0 2px 10px rgba(0,0,0,0.2)'
    ].join(';');
    overlayEl.appendChild(spinner);

    document.body.appendChild(overlayEl);
    return overlayEl;
  }

  function showLoader() {
    ensureOverlay().style.display = 'block';
  }

  function hideLoader() {
    if (overlayEl) overlayEl.style.display = 'none';
  }

  // --- Conversion automatique Solo -> Duo/Trio ------------------------------
  // Quand la quantité du produit "Solo" (le produit déclencheur) atteint 2 ou 3
  // dans le panier, on la remplace par 1x le vrai produit-bundle correspondant
  // (Duo/Trio), tagué avec _bundle_equivalent_qty pour que les cadeaux et
  // l'affichage restent cohérents avec le reste du système.
  async function maybeUpgradeBundle(cart) {
    const bundleUpgrade = config.bundleUpgrade;
    if (!bundleUpgrade || !bundleUpgrade.triggerVariantId) return false;

    const soloLines = cart.items.filter(
      (item) =>
        item.variant_id === bundleUpgrade.triggerVariantId &&
        !(item.properties && (item.properties._cadeau || item.properties._gift_label))
    );

    const soloQuantity = soloLines.reduce((sum, item) => sum + item.quantity, 0);

    let targetVariantId = null;
    let equivalentQuantity = null;

    if (bundleUpgrade.trioVariantId && soloQuantity >= 3) {
      targetVariantId = bundleUpgrade.trioVariantId;
      equivalentQuantity = 3;
    } else if (bundleUpgrade.duoVariantId && soloQuantity >= 2) {
      targetVariantId = bundleUpgrade.duoVariantId;
      equivalentQuantity = 2;
    } else {
      return false;
    }

    const removalUpdates = {};
    soloLines.forEach((item) => {
      removalUpdates[item.key] = 0;
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: removalUpdates })
    });

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: targetVariantId,
            quantity: 1,
            properties: { _bundle_equivalent_qty: String(equivalentQuantity) }
          }
        ]
      })
    });

    return true;
  }

  let isSyncing = false;
  let pendingResync = false;

  async function syncGifts() {
    if (isSyncing) {
      pendingResync = true;
      return;
    }
    isSyncing = true;
    showLoader();

    let reloading = false;

    try {
      let cart = await fetch('/cart.js', { headers: { accept: 'application/json' } }).then((r) => r.json());

      const upgraded = await maybeUpgradeBundle(cart);
      if (upgraded) {
        reloading = true;
        window.location.reload();
        return;
      }

      let qualifyingQuantity = 0;
      for (const item of cart.items) {
        const isGiftLine = Boolean(item.properties && (item.properties._cadeau || item.properties._gift_label));
        if (isGiftLine) continue;

        // Un produit-bundle (Duo/Trio) ajouté depuis le sélecteur de la page produit porte la
        // propriété _bundle_equivalent_qty : une seule unité compte alors pour 2 ou 3 pots, même
        // si ce n'est pas le produit "déclencheur" habituel (cas des vrais produits-bundles Shopify).
        const bundleEquivalentQty = item.properties && parseInt(item.properties._bundle_equivalent_qty, 10);
        if (bundleEquivalentQty) {
          qualifyingQuantity += bundleEquivalentQty * item.quantity;
          continue;
        }

        if (config.triggerProductId) {
          if (item.product_id === config.triggerProductId) {
            qualifyingQuantity += item.quantity;
          }
        } else {
          qualifyingQuantity += item.quantity;
        }
      }

      const additions = [];
      const removalUpdates = {};

      for (const gift of gifts) {
        // Une ligne n'est considérée comme "le cadeau déjà présent" que si elle porte
        // à la fois la bonne variante ET la propriété _cadeau — jamais une ligne
        // normale (achetée volontairement) du même produit.
        const matchingLines = cart.items.filter(
          (item) => item.variant_id === gift.variantId && item.properties && item.properties._cadeau
        );

        // Auto-réparation : si une synchronisation précédente (concurrente, ex. deux
        // onglets/pages) a créé plusieurs lignes pour le même cadeau, on ne garde que
        // la première et on supprime les doublons.
        if (matchingLines.length > 1) {
          for (let i = 1; i < matchingLines.length; i++) {
            removalUpdates[matchingLines[i].key] = 0;
          }
        }

        const existingLine = matchingLines[0];
        const shouldHaveGift = qualifyingQuantity >= gift.unlockQuantity;

        if (shouldHaveGift && !existingLine) {
          // On ne pousse jamais deux fois le même variantId dans le même cycle de sync.
          if (!additions.some((addition) => addition.id === gift.variantId)) {
            additions.push({
              id: gift.variantId,
              quantity: 1,
              properties: { _cadeau: 'true', _gift_label: gift.label }
            });
          }
        } else if (!shouldHaveGift && existingLine) {
          removalUpdates[existingLine.key] = 0;
        }
      }

      let mutated = false;

      if (Object.keys(removalUpdates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: removalUpdates })
        });
        mutated = true;
      }

      if (additions.length > 0) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: additions })
        });
        mutated = true;
      }

      if (mutated) {
        // Shopify réattribue la clé interne des AUTRES lignes du panier (y compris
        // le produit principal) dès qu'on ajoute/retire une ligne cadeau. Les
        // boutons quantité/supprimer du thème gardent l'ancienne référence en
        // mémoire et échouent (422) après coup. Un rechargement complet est le
        // seul moyen fiable de reposer sur des références toujours à jour.
        reloading = true;
        window.location.reload();
      }
    } catch (error) {
      console.error('[cart-gifts-sync]', error);
    } finally {
      isSyncing = false;
      if (reloading) {
        // On laisse le voile affiché : la page va se recharger dans l'instant.
      } else if (pendingResync) {
        pendingResync = false;
        syncGifts();
      } else {
        hideLoader();
      }
    }
  }

  const originalFetch = window.fetch.bind(window);
  window.fetch = function (resource, options) {
    const url = typeof resource === 'string' ? resource : resource && resource.url;
    const promise = originalFetch(resource, options);

    if (isCartMutationUrl(url) && !isSyncing) {
      // On affiche le voile de chargement dès que la requête native part (pas
      // seulement une fois notre propre synchronisation démarrée), pour bloquer
      // tout double-clic pendant que la requête du client est encore en vol.
      showLoader();
      promise.finally(() => {
        setTimeout(syncGifts, 400);
      });
    }

    return promise;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGifts);
  } else {
    syncGifts();
  }
})();